import { getAppBaseInfo } from './app';

const TEST_ENVS = ['development', 'test', 'test2', 'test3', 'test4'];

/** 是否为测试/开发环境 */
export function isTestEnv(): boolean {
  return TEST_ENVS.includes(import.meta.env.VITE_APP_ENV);
}

const ENV_CODE_MAP: Record<string, string> = {
  production: '4',
  pre: '3',
  test: '2',
  test2: '2',
  test3: '2',
  test4: '2',
  development: '1'
};

/** 获取当前环境编码，用于埋点/错误上报 */
export function getEnvCode(): string {
  return ENV_CODE_MAP[import.meta.env.VITE_APP_ENV] || '-1';
}

const ENV_INDEX_MAP: Record<string, number> = {
  development: 0,
  dev: 0,
  test: 1,
  test2: 1,
  test3: 1,
  test4: 1,
  pre: 2,
  production: 3
};

/** 获取当前环境索引，用于游戏 serverId 选择 */
export function getEnvIndex(): number {
  const env = import.meta.env.VITE_APP_ENV || 'production';
  return ENV_INDEX_MAP[env] ?? ENV_INDEX_MAP.production;
}

/** 测试环境标识 → API 地址映射 */
const TEST_ENV_URL_MAP: Record<string, string> = {
  dev: 'http://192.168.1.61:12301',
  test: 'https://api-test.docoi.cc',
  test2: 'https://api-test2.docoi.cc',
  test3: 'https://api-test3.docoi.cc',
  test4: 'https://api-test4.docoi.cc'
};

/**
 * 获取 API 基础地址
 * 测试环境下优先读取 App 运行时环境标识匹配对应 URL，始终跟客户端环境走
 * 匹配失败或非测试环境则使用构建时的 BASE_URL 兜底
 */
export function getApiBaseUrl(): string {
  // 本地开发或非测试环境（pre/prod）不做动态切换，直接使用构建时 BASE_URL
  if (import.meta.env.DEV || !isTestEnv()) {
    return import.meta.env.VITE_APP_BASE_URL;
  }

  const appBaseInfo = getAppBaseInfo();
  const envKey = appBaseInfo?.env;
  if (envKey && TEST_ENV_URL_MAP[envKey]) {
    return TEST_ENV_URL_MAP[envKey];
  }

  return import.meta.env.VITE_APP_BASE_URL;
}
